<template>
	<div class="common_layout user_total_layout">
		<div v-if="codeStatus.value === 'fail'">
			<div class="center_flex_layout" style="margin-top: 84px">
				<img
					style="width: 302px; height: 276px"
					src="../../assets/images/createcode_invalid_img.png"
				/>
			</div>

			<p class="invalid_code_font">请使用支付宝或微信扫码支付</p>
		</div>
	</div>
</template>

<script setup>
import { reactive, onMounted, getCurrentInstance } from "vue";
import { get, post } from "../../utils/request";
import { Encrypt } from "../../utils/secret";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance();

const codeStatus = reactive({ value: "none" });
const payMethod = reactive({ value: "" });
const checkoutType = reactive({ value: "" });
const orderNum = reactive({ value: "" });
const wechatCode = reactive({ value: "" });
const wechatId = reactive({ value: "" });
const payNow = reactive({ value: "" });
// 获取用户代理字符串
let userAgent = navigator.userAgent.toLowerCase();

// 判断是否在支付宝内打开
if (userAgent.indexOf("alipay") !== -1) {
	// console.log('在支付宝内打开');
	payMethod.value = "ALIPAY";
	checkoutType.value = "MWEB";
}

// 判断是否在微信内打开
if (userAgent.indexOf("micromessenger") !== -1) {
	// console.log('在微信内打开');
	payMethod.value = "WEIXIN";
	checkoutType.value = "JSAPI";
}

let getUrlParams = new URLSearchParams(window.location.search);

wechatCode.value = getUrlParams.get("code");

orderNum.value = getUrlParams.get("state");

onMounted(() => {
	if (payMethod.value) {
		if (payMethod.value === "WEIXIN") {
			if (!wechatCode.value) {
				getWechatCode();
			} else {
				getOpenId();
			}
		} else {
			let payParams = {
				payMethodType: payMethod.value,
				checkoutTypeVal: checkoutType.value,
				orderId: orderNum.value,
			};
			let payDataParams = encodeURIComponent(Encrypt(JSON.stringify(payParams)));
			router.push("/payingFail?data=" + payDataParams);
		}
	} else {
		codeStatus.value = "fail";
	}
});

// 获取微信授权
const getWechatCode = () => {
	let selfUrl = encodeURIComponent("https://api.sancttech.com");

	window.location.href =
		"https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5e367231086ae039&redirect_uri=" +
		selfUrl +
		"&response_type=code&scope=snsapi_base&state=" +
		orderNum.value +
		"#wechat_redirect";
};

// 获取openID
const getOpenId = () => {
	get("/user/weixin/openid?code=" + wechatCode.value, {})
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				let payParams = {
					payMethodType: payMethod.value,
					checkoutTypeVal: checkoutType.value,
					orderId: orderNum.value,
					openId: res.result.openid,
				};
				let payDataParams = encodeURIComponent(Encrypt(JSON.stringify(payParams)));
				router.push("/payingFail?data=" + payDataParams);
			}
		})
		.catch((error) => {
			alert(error);
		});
};
</script>
